import React, { useEffect, useState } from 'react'
import PlantillaScreen from '../helpers/PlantillaScreen'
import { Autocomplete, TextField, Button } from '@mui/material';
import request from '../../Helpers/API';
import { GetKey, GetText } from '../../Helpers/GetKey';
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from '@mui/icons-material/Person';

export const PermisosUsuariosMainScreen = () => {
    const history = useHistory();
    const [usuariolist, setUsuarioList] = useState([]);
    const [state, setState] = useState({
        usuarioselect: "",
        usuariosearch: "",
        titulosolicitud: "SELECCIONAR USUARIO",
        idusuario: 0,
    });
    

    useEffect(() => {
        request
            .get("BuscarUsuario/DropDownList")
            .then((result) => {
                setUsuarioList(result);
            })
            .catch((error) => {
                JSON.stringify("PERMISOS", "ERROR....", "error");
            });
    }, []);


    const onAgregar = () => {
        history.push("/Permisos/Agregar");
    };


    const onBuscar = () => {
        const usuario = GetText(state.usuariosearch)
        const idusuario = GetKey(state.usuariosearch)

        if (idusuario === null || idusuario === 0 || idusuario === "") {
            Swal.fire({
                title: "PERMISOS USUARIOS",
                text: "Seleccione un usuario",
                icon: "error",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        else {
            history.push("/Permisos/UsuarioSeleccionado", {
                usuario,
                idusuario,
            })
        }
    };

    const onHome = () => {
        history.push("/Permisos/Main")
    };
    return (
        <PlantillaScreen
            titulo={"PERMISOS DE USUARIO"}
            className_main={1}
            className={"permisos-usuarios-main-screen"}
        >
            <div>
                <div className='permisos-usuarios-agregar-usuario'>
                    <div className='permisos-usuarios-buscar-cliente'>
                        <div className='permisos-usuarios-input-buscar-cliente'>
                            <Autocomplete
                                size="small"
                                id="dash-razonsocial"
                                freeSolo
                                // className="dash-cliente-search-razonsocial"
                                value={state.usuariosearch}
                                onChange={(_, newValue) => {
                                    setState({ ...state, usuariosearch: newValue });
                                    // Navigate to the selected user route
                                }}
                                options={usuariolist.map(
                                    (option) => `${option.id} - ${option.display}`
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="Seleccione un Usuario... " />
                                )}

                            />
                        </div>
                        <div className='permisos-usuarios-botones-container'>
                            <Button
                                variant="contained"
                                sx={{ height: 35 }}
                                className='permisos-usuario-boton-buscar-usuario'
                                // onClick={handleOpenModal}
                                onClick={() => onBuscar()}
                            >
                                <SearchIcon />
                            </Button>
                            <Button
                                variant="contained"
                                className='permiso-usuario-boton-agregar-nuevo-usuario'
                                // onClick={handleOpenModal}
                                onClick={() => onAgregar()}
                            >
                                <PersonIcon />
                                Agregar
                            </Button>
                        </div>
                    </div>
                    <div>

                    </div>
                </div>
                <div>
                    <div className="inicio" onClick={() => onHome()}>
                        <ArrowBackIcon /> Regresar
                    </div>
                </div>

            </div>
        </PlantillaScreen>
    )
}